import { UsageOfgemMap } from "@/services/UsageEstimationService/types"

const usageProfilesOfgem: UsageOfgemMap = {
  Low: {
    gasUsage: 6000,
    electricityUsage: 1600,
    electricityTwoRateUsage: 1900,
  },
  Medium: {
    gasUsage: 9500,
    electricityUsage: 2500,
    electricityTwoRateUsage: 3400,
  },
  High: {
    gasUsage: 14000,
    electricityUsage: 3800,
    electricityTwoRateUsage: 6100,
  },
}

export default usageProfilesOfgem
